import Vue from "vue";
import VueRouter from "vue-router";
import Boilerplate from "./views/Boilerplate.vue";
import Dashboard from "./views/Dashboard.vue";
import SoftwareDetails from "./views/SoftwareDetails.vue";
import Login from "./views/Login.vue";
import AdminDashboard from "./views/AdminDashboard.vue";
import Error404 from "./views/Error404.vue";
import ClientDetails from "./views/ClientDetails.vue";
import Servers from "./views/Servers.vue";

import { api } from "@/general";

Vue.use(VueRouter);
const roleGuest = "guest";
const roleUser = "user";
const roleAdmin = "admin";

const routes = [
  {
    path: "/",
    name: "home",
    component: Error404, // Pas besoin de page ici
    meta: {
      permissions: [
        {
          role: roleGuest,
          access: false,
          redirect: "login"
        },
        {
          role: roleUser,
          access: false,
          redirect: "dashboard"
        },
        {
          role: roleAdmin,
          access: false,
          redirect: "adminDashboard"
        }
      ]
    }
  },
  {
    path: "/login",
    name: "login",
    component: Login,
    meta: {
      permissions: [
        {
          role: roleUser,
          access: false,
          redirect: "dashboard"
        },
        {
          role: roleAdmin,
          access: false,
          redirect: "adminDashboard"
        }
      ]
    }
  },
  {
    path: "/boilerplate",
    name: "boilerplate",
    component: Boilerplate,
    meta: {
      permissions: [
        {
          role: roleGuest,
          access: false,
          redirect: "login"
        }
      ]
    }
  },

  {
    path: "/dashboard",
    name: "dashboard",
    component: Dashboard,
    meta: {
      permissions: [
        {
          role: roleGuest,
          access: false,
          redirect: "login"
        },
        {
          role: roleAdmin,
          access: false,
          redirect: "adminDashboard"
        }
      ]
    }
  },
  {
    path: "/softwares/:id",
    name: "details",
    component: SoftwareDetails,
    beforeEnter: async (to, from, next) => {
      // Récupère le logiciel
      let respSoftware = await api.getSoftware(to.params.id);
      // Vérifie que le logiciel existe
      if (respSoftware.status === 400) {
        next("/404");
        // Vérifie si le l'utilisateur a accès au logiciel
      } else if (respSoftware.status == 200) {
        // Vérifie si l'utilisateur est un client
        if (!Vue.prototype.$user.get().role == roleUser) {
          // Récupère le serveur du logiciel
          let respServer = await api.getServer(
            respSoftware.data.data.serveur_id
          );
          // Vérifie si le serveur existe
          if (respServer.status == 400) {
            next("/404");
            // Vérifie si le serveur appartient au client
          } else if (
            respServer.data.data.client_id !=
            Vue.prototype.$user.get().client_id
          ) {
            next("/dashboard");
          }
        }
      }
      next();
    },
    meta: {
      permissions: [{ role: roleGuest, access: false, redirect: "login" }]
    }
  },
  {
    path: "/clients/:client_id/servers",
    name: "servers",
    component: Servers,
    beforeEnter: async (to, from, next) => {
      let resp = await api.getClient(to.params.client_id);
      if (resp.status === 400) {
        next("/404");
      }
      next();
    },
    meta: {
      permissions: [
        {
          role: roleGuest,
          access: false,
          redirect: "login"
        },
        {
          role: roleUser,
          access: (user, to) => user.client_id == to.params.client_id,
          redirect: "dashboard"
        }
      ]
    }
  },
  // ---- Insérer routes Client avant cette ligne ----
  {
    path: "/admin",
    name: "adminDashboard",
    component: AdminDashboard,
    meta: {
      permissions: [
        {
          role: roleGuest,
          access: false,
          redirect: "login"
        },
        {
          role: roleUser,
          access: false,
          redirect: "404"
        }
      ]
    }
  },
  {
    path: "/clients/:id",
    name: "clientDetails",
    component: ClientDetails,
    beforeEnter: async (to, from, next) => {
      let resp = await api.getClient(to.params.id);
      if (resp.status === 400) {
        next("/404");
      }
      next();
    },
    meta: {
      permissions: [
        {
          role: roleGuest,
          access: false,
          redirect: "login"
        },
        {
          role: roleUser,
          access: false,
          redirect: "404"
        }
      ]
    }
  },
  // ---- Insérer routes admin avant cette ligne ----
  {
    path: "/admin/*",
    component: Error404,
    meta: {
      permissions: [
        {
          role: roleGuest,
          access: false,
          redirect: "login"
        },
        {
          role: roleUser,
          access: false,
          redirect: "404"
        }
      ]
    }
  },
  {
    path: "/404",
    name: "404",
    component: Error404,
    meta: {
      permissions: [
        {
          role: roleGuest,
          access: false,
          redirect: "login"
        }
      ]
    }
  },
  {
    path: "*",
    meta: {
      permissions: [
        {
          role: roleGuest,
          access: false,
          redirect: "login"
        },
        {
          role: roleUser,
          access: false,
          redirect: "404"
        },
        {
          role: roleAdmin,
          access: false,
          redirect: "404"
        }
      ]
    }
  }
];
const router = new VueRouter({
  mode: "history",
  routes
});
export default router;
